import { Button, Divider, FormControl, Grid, IconButton, InputLabel, MenuItem, Paper, Select, Tab, Tabs, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useState, useEffect, useContext } from "react";
import YourMentors from "../../Mentorship/Yourmentors";
import AppSearchBar from "../../../Components/AppSearchBar";
import MentorshipContainer from "../../Mentorship/Mentorship";
import { featuredCardData } from "../../Network/NetworkData";
import CloseIcon from '@mui/icons-material/Close';
import { useStyles } from './style';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import PhotoContainer from "./PhotoContainer";
import AlbumContainer from "./AlbumContainer";
import { getPhotosAndAlbums } from "../../../Utils/apiService";
import { AuthContext } from "../../../Helpers/Contexts/authContext";
import { AuthUser } from "../../../interfaces/Contexts";
import { useNavigate } from "react-router-dom";
import routes from "../../../Utils/routes";
import CreateAlbumModal from "./Components/createAlbum";
const sampleData = [
  {
    id: 1,
    userName: 'Ranav J',
    avatarUrl: 'https://randomuser.me/api/portraits/men/32.jpg',
    imageUrl: 'https://3.img-dpreview.com/files/p/TS600x600~sample_galleries/9737283555/4421694065.jpg',
    likes: 124,
    comments: 96,
  },
  {
    id: 2,
    userName: 'Akash Sharma',
    avatarUrl: 'https://randomuser.me/api/portraits/men/41.jpg',
    imageUrl: 'https://images.unsplash.com/photo-1595152772835-219674b2a8a6',
    likes: 96,
    comments: 20,
  },
  {
    id: 3,
    userName: 'Sanjay Kumar',
    avatarUrl: 'https://randomuser.me/api/portraits/men/50.jpg',
    imageUrl: 'https://images.unsplash.com/photo-1588702547923-7093a6c3ba33',
    likes: 56,
    comments: 29,
  },
  {
    id: 4,
    userName: 'Praveen Kumar',
    avatarUrl: 'https://randomuser.me/api/portraits/men/60.jpg',
    imageUrl: 'https://petapixel.com/assets/uploads/2023/05/Z_DX24_F1.7_02_FK_5975_A4-800x534.jpg',
    likes: 89,
    comments: 45,
  },
];

const sampleData2 = [
  {
    id: 1,
    userName: 'Ranav J',
    avatarUrl: 'https://randomuser.me/api/portraits/men/32.jpg',
    imageUrl: 'https://3.img-dpreview.com/files/p/TS600x600~sample_galleries/9737283555/4421694065.jpg',
    collaborators: 16,
    title: "Back to where It began",
    Lastupdated: "30 May, 2025"
  },
  {
    id: 2,
    userName: 'Akash Sharma',
    avatarUrl: 'https://randomuser.me/api/portraits/men/41.jpg',
    imageUrl: 'https://images.unsplash.com/photo-1595152772835-219674b2a8a6',
    collaborators: 6,
    title: "Footprints of friendship",
    Lastupdated: "1 May, 2025"
  },
  {
    id: 3,
    userName: 'Sanjay Kumar',
    avatarUrl: 'https://randomuser.me/api/portraits/men/50.jpg',
    imageUrl: 'https://images.unsplash.com/photo-1588702547923-7093a6c3ba33',
    collaborators: 9,
    title: "Alumni gala 2025",
    Lastupdated: "30 jun, 2025"
  },
  {
    id: 4,
    userName: 'Praveen Kumar',
    avatarUrl: 'https://randomuser.me/api/portraits/men/60.jpg',
    imageUrl: 'https://petapixel.com/assets/uploads/2023/05/Z_DX24_F1.7_02_FK_5975_A4-800x534.jpg',
    collaborators: 10,
    title: "Squad goals in action",
    Lastupdated: "3 May, 2025"
  },
];

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
const Photos = () => {
  let recognition: any = null;
  const [value, setValue] = React.useState(() => {
    const savedTab = localStorage.getItem('photoAlbumActiveTab');
    return savedTab ? parseInt(savedTab, 10) : 0;
  }); const [photoSearchInput, setPhotoSearchInput] = useState<string>('');
  const [photoLocalSearchInput, setPhotoLocalSearchInput] = useState('');
  const [photoSortby, setPhotoSortby] = useState('');
  const [albumSearchInput, setAlbumSearchInput] = useState<string>('');
  const [albumLocalSearchInput, setAlbumLocalSearchInput] = useState('');
  const [albumSortby, setAlbumSortby] = useState('');
  const classes = useStyles();
  const [notificationOpen, setNotificationOpen] = useState(false);
  const [photosData, setPhotosData] = useState<any[]>([]);
  const [albumsData, setAlbumsData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const { state: { user } } = useContext(AuthContext);
  const [createAlbumModalOpen, setCreateAlbumModalOpen] = useState(false);
  const userData = user as AuthUser;
  const navigate = useNavigate();

  useEffect(() => {
    fetchPhotosAndAlbums();
  }, []);

  const fetchPhotosAndAlbums = async () => {
    setLoading(true);
    try {
      const response = await getPhotosAndAlbums();
      console.log("Photos and Albums API response:", response);

      if (response && response.data && response.data.data) {
        const photos = response.data.data.photos || [];
        const albums = response.data.data.albums || [];

        setPhotosData(photos);
        setAlbumsData(albums);

        localStorage.setItem('albumsData', JSON.stringify(albums));
      }
    } catch (error) {
      console.error("Error fetching photos and albums:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddAlbumClick = () => {
    setCreateAlbumModalOpen(true);
  };

  const handleAlbumCreationSuccess = () => {
    fetchPhotosAndAlbums(); // Refresh the data
  };


  const handleAddPhotosClick = () => {
    const albumsInfo = albumsData.map(album => ({
      id: album.Id,
      name: album.Name,
    }));
    const photosInfo = photosData.map(photo => ({
      id: photo.Id,
      name: photo.Name,
      fileLink: photo.File_Link__c,
      description: photo.Description__c,
      location: photo.Location__c,
      createdDate: photo.CreatedDate
    }));

    console.log("Albums Info:", albumsInfo);
    console.log("Photos Info:", photosInfo);

    navigate(routes.PhotoAlbumUpload, {
      state: {
        albums: albumsInfo,
        photos: photosInfo
      }
    });
  };
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    localStorage.setItem('photoAlbumActiveTab', newValue.toString());
  };
  const handleMicRelease = () => {
    if (recognition) {
      recognition.stop();
    }
  };
  const [Sortby, setSortby] = useState('');
  const handleMicHold = () => {
    setNotificationOpen(true);
    if ('SpeechRecognition' in window || 'webkitSpeechRecognition' in window) {
      recognition = new (window.SpeechRecognition || window.webkitSpeechRecognition)();
      recognition.lang = 'en-US';
      recognition.onstart = () => {
        console.log('Speech recognition started');
      };
      recognition.onresult = (event: SpeechRecognitionEvent) => {
        const speechResult = event.results[0][0].transcript;
        if (value === 0) {
          setPhotoLocalSearchInput(speechResult);
          setPhotoSearchInput(speechResult);
        } else {
          setAlbumLocalSearchInput(speechResult);
          setAlbumSearchInput(speechResult);
        }
      };
      recognition.onerror = (event: { error: any }) => {
        console.error('Speech recognition error:', event.error);
      };
      recognition.onnomatch = (event: any) => {
        console.warn('No speech recognized:', event);
      };
      recognition.onspeechend = (event: any) => {
        console.log('Speech recognition ended:', event);
      };
      recognition.onend = () => {
        console.log('Speech recognition stopped');
        setNotificationOpen(false);
      };
      recognition.start();
    } else {
      console.log('Speech recognition not supported');
    }
  };
  const handleChanges = (event: any) => {
    const sortOption = event.target.value;
    if (value === 0) {
      setPhotoSortby(sortOption);
    } else {
      setAlbumSortby(sortOption);
    }
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (value === 0) {
      setPhotoSearchInput(e.target.value);
      setPhotoLocalSearchInput(e.target.value);
    } else {
      setAlbumSearchInput(e.target.value);
      setAlbumLocalSearchInput(e.target.value);
    }
  };

  const filterAndSortDataPhotos = (data: any[]) => {
    const filtered = data.filter(item =>
      item.Name.toLowerCase().includes(photoSearchInput.toLowerCase())
    );
    if (photoSortby === "A - Z") {
      return filtered.sort((a, b) => a.Name.localeCompare(b.Name));
    } else if (photoSortby === "Z - A") {
      return filtered.sort((a, b) => b.Name.localeCompare(a.Name));
    }
    return filtered;
  };

  const filterAndSortDataAlbums = (data: any[]) => {
    const filtered = data.filter(item =>
      item.Name.toLowerCase().includes(albumSearchInput.toLowerCase())
    );
    if (albumSortby === "A - Z") {
      return filtered.sort((a, b) => a.Name.localeCompare(b.Name));
    } else if (albumSortby === "Z - A") {
      return filtered.sort((a, b) => b.Name.localeCompare(a.Name));
    }
    return filtered;
  };

  const displayedPhotos = filterAndSortDataPhotos(photosData);
  const displayedAlbums = filterAndSortDataAlbums(albumsData);
  return (
    <Box
      sx={{
        height: '87vh',
        textAlign: "left",
        '@media (min-width: 1280px) and (max-width: 1300px)': {
          height: '85vh',
        },
      }}
      className="scrollbar-cusgrayHeader"
    >
      <Grid container style={{ textAlign: "left", position: "sticky", top: 0, zIndex: 10 }}>
        <Grid item md={12} lg={12} xl={12} xs={12} style={{ backgroundColor: "white", marginTop: "15px", padding: "15px 15px 0px 15px", borderRadius: "8px" }}>
          <Box>
            <Tabs TabIndicatorProps={{
              style: {
                backgroundColor: '#FAB400'
              },
            }}
              value={value} onChange={handleChange} aria-label="basic tabs example">
              <Tab
                label="Photos"
                {...a11yProps(0)}
                sx={{
                  textTransform: 'none',
                  '&.Mui-selected': {
                    color: '#373A45', // or use theme color like '#FFC107'
                  }
                }}
              />
              <Tab
                label="Album"
                {...a11yProps(1)}
                sx={{
                  textTransform: 'none',
                  '&.Mui-selected': {
                    color: '#373A45',
                  }
                }}
              />
            </Tabs>
          </Box>
        </Grid>
      </Grid>
      <CustomTabPanel value={value} index={0}>
        <Grid container style={{ height: "74.3vh", overflow: "hidden" }}>
          <Grid item lg={12} xl={12} style={{ backgroundColor: "white", borderRadius: "8px", padding: 15 }}>
            <Grid style={{ marginBottom: 10, position: "sticky", top: 0, zIndex: 5, backgroundColor: "white" }} container spacing={1}>
              <Grid item xs={12} md={5.8} lg={5.8} xl={5.8}>
                <Typography
                  sx={{
                    fontSize: '15px',
                    color: '#373A45',
                    fontWeight: '500',
                    textAlign: 'start',
                    mb: { xs: 2, md: 0 },
                    '@media (max-width: 600px)': {
                      fontSize: '16px',
                    },
                    '@media (min-width: 1280px) and (max-width: 1300px)': {
                      fontSize: '12px !important',
                    },
                    '@media (min-width: 1920px) and (max-width: 1940px)': {
                      fontSize: '20px !important',
                    },
                  }}
                >
                  {'All Photos'}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3} sx={{ mb: { xs: 2, md: 0 } }}>
                <AppSearchBar
                  handleMicHold={handleMicHold}
                  handleMicRelease={handleMicRelease}
                  localSearchInput={photoLocalSearchInput}
                  openSnackbar={notificationOpen}
                  handleChange={handleSearchChange}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={1.5} lg={1.5} xl={1.5} sx={{ mb: { xs: 2, md: 0 } }}>
                <FormControl
                  fullWidth
                  size="small"
                  sx={{
                    '@media (min-width: 600px)': {
                      width: '95%',
                      float: "right",
                      paddingRight: "3%",
                    }
                  }}
                >
                  <InputLabel id="photo-sort-label">Sort by</InputLabel>
                  <Select
                    labelId="photo-sort-label"
                    id="photo-sort-select"
                    value={photoSortby}
                    label="Sort by"
                    onChange={handleChanges}
                  >
                    <MenuItem value="">Clear</MenuItem>
                    <MenuItem value={"A - Z"}>A - Z</MenuItem>
                    <MenuItem value={"Z - A"}>Z - A</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6} sm={6} md={1} lg={1} xl={1} sx={{ mb: { xs: 2, md: 0 } }}>
                <Button
                  fullWidth
                  sx={{
                    color: "white",
                    backgroundColor: "#0B3E69",
                    borderRadius: 6,
                    fontWeight: "400",
                    fontSize: 12,
                    height: { xs: '40px', md: 'auto' },
                    '&:hover': {
                      backgroundColor: "#0a3456"
                    },
                    '@media (min-width: 600px)': {
                      width: "95%",
                      float: "right"
                    }
                  }}
                  onClick={handleAddPhotosClick}
                >
                  Add photos +
                </Button>
              </Grid>
            </Grid>
            <Grid
              className={`scrollbar-cusgray ${classes.cardContainer}`}
              style={{ overflowY: "auto", height: "calc(100% - 60px)" }}>
              <PhotoContainer cardData={displayedPhotos} />
            </Grid>
          </Grid>
        </Grid>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <Grid container style={{ height: "74.3vh" }}>
          <Grid item lg={12} xl={12} style={{ backgroundColor: "white", borderRadius: "8px", padding: 15 }}>
            <Grid style={{ marginBottom: 10 }} container spacing={1}>
              <Grid item xs={12} md={5.8} lg={5.8} xl={5.8}>
                <Typography
                  sx={{
                    fontSize: '15px',
                    color: '#373A45',
                    fontWeight: '500',
                    textAlign: 'start',
                    mb: { xs: 2, md: 0 },
                    '@media (max-width: 600px)': {
                      fontSize: '16px',
                    },
                    '@media (min-width: 1280px) and (max-width: 1300px)': {
                      fontSize: '12px !important',
                    },
                    '@media (min-width: 1920px) and (max-width: 1940px)': {
                      fontSize: '20px !important',
                    },
                  }}
                >
                  {'All Album'}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3} sx={{ mb: { xs: 2, md: 0 } }}>
                <AppSearchBar
                  handleMicHold={handleMicHold}
                  handleMicRelease={handleMicRelease}
                  localSearchInput={albumLocalSearchInput}
                  openSnackbar={notificationOpen}
                  handleChange={handleSearchChange}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={1.5} lg={1.5} xl={1.5} sx={{ mb: { xs: 2, md: 0 } }}>
                <FormControl
                  fullWidth
                  size="small"
                  sx={{
                    '@media (min-width: 600px)': {
                      width: '95%',
                      float: "right",
                      paddingRight: "3%",
                    }
                  }}
                >
                  <InputLabel id="album-sort-label">Sort by</InputLabel>
                  <Select
                    labelId="album-sort-label"
                    id="album-sort-select"
                    value={albumSortby}
                    label="Sort by"
                    onChange={handleChanges}
                  >
                    <MenuItem value="">Clear</MenuItem>
                    <MenuItem value={"A - Z"}>A - Z</MenuItem>
                    <MenuItem value={"Z - A"}>Z - A</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6} sm={6} md={1} lg={1} xl={1} sx={{ mb: { xs: 2, md: 0 } }}>
                <Button
                  fullWidth
                  sx={{
                    color: "white",
                    backgroundColor: "#0B3E69",
                    borderRadius: 6,
                    fontWeight: "400",
                    fontSize: 12,
                    height: { xs: '40px', md: 'auto' },
                    '&:hover': {
                      backgroundColor: "#0a3456"
                    },
                    '@media (min-width: 600px)': {
                      width: "95%",
                      float: "right"
                    }
                  }}
                  onClick={handleAddAlbumClick}
                >
                  Add Album +
                </Button>
              </Grid>
              <CreateAlbumModal
                open={createAlbumModalOpen}
                onClose={() => setCreateAlbumModalOpen(false)}
                onSuccess={handleAlbumCreationSuccess}
              />
            </Grid>
            <Grid
              className={`scrollbar-cusgray ${classes.cardContainer}`}>
              <AlbumContainer cardData={displayedAlbums} />
            </Grid>
          </Grid>

        </Grid>
      </CustomTabPanel>
    </Box>
  );
};
export default Photos;
